module.exports = __webpack_public_path__ + "static/img/page_4_1.30b3deb.png";


//////////////////
// WEBPACK FOOTER
// ./static/otherpage/page_4_1.png
// module id = C9k6
// module chunks = 1